import * as Ant from 'antd';
import { LaptopOutlined, HomeFilled, ControlOutlined, FireOutlined, LogoutOutlined } from '@ant-design/icons';
import React from 'react';
import { NavLink, useLocation } from 'react-router';

import { logout } from '../../data/thunks';
import { useAppDispatch } from '../../data/store';

interface Props {
  renderMenu?: boolean;
  title?: string;
}

const menuItems: Ant.MenuProps['items'] = [
  { key: '/home', icon: <HomeFilled />, label: <NavLink to="/home">Overview</NavLink> },
  { key: '/settings', icon: <ControlOutlined />, label: <NavLink to="/settings">Settings</NavLink> },
  {
    key: '/monitored-applications',
    icon: <LaptopOutlined />,
    label: <NavLink to="/monitored-applications">Monitored Applications</NavLink>,
  },
  { key: '/load-test', icon: <FireOutlined />, label: <NavLink to="/load-test">Load Test</NavLink> },
];

const Header = (props: Props) => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  return (
    <Ant.Layout.Header style={{ display: 'flex' }}>
      <img style={{ padding: 16 }} alt="" src="assets/img/white.png" />
      <Ant.Divider
        style={{
          marginLeft: 16,
          marginRight: 32,
          height: '60%',
          alignSelf: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.65)',
        }}
        orientation="vertical"
      />
      {props.title && (
        <Ant.Typography.Title style={{ color: '#f0f2f5', alignSelf: 'center', marginBottom: 0 }} level={5}>
          {props.title}
        </Ant.Typography.Title>
      )}
      {props.renderMenu && (
        <>
          <Ant.Menu
            style={{ width: '100%' }}
            theme="dark"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
          />
          <div style={{ flex: 1 }} />
          <LogoutOutlined style={{ color: 'white', alignSelf: 'center' }} onClick={() => dispatch(logout())} />
        </>
      )}
    </Ant.Layout.Header>
  );
};

export default Header;
